import type { VoidFunctionComponent } from 'react';
import { TooltipContent } from '../../../generic';
import Icon, { icons } from '../../../generic/Icon';
import Tooltip from '../../../generic/Tooltip';

/**
 * Displays a Unverified badge.
 */
const UnverifiedBadge: VoidFunctionComponent = () => (
  <Tooltip
    id="unverified-badge"
    tooltip={
      <TooltipContent>This vulnerability was identified based on a CPE with limited
        context in the SBOM and could not be verified by FOSSA.
      </TooltipContent>
    }
  >
    <div className="issue-item__text">
      <Icon icon={icons.questionCircleO} /> Unverified
    </div>
  </Tooltip>
);

export default UnverifiedBadge;
